var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page3warp"},[(_vm.contentObj)?_c('div',{staticClass:"institutionalbox"},[_c('div',{staticClass:"img",domProps:{"innerHTML":_vm._s(_vm.contentObj)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }